( ( { hooks: { addAction: addActionBe } }, { hooks: { addAction: addActionFe } } ) => { // eslint-disable-line
} )( wp, feWp ); // eslint-disable-line 
